<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="150px">
            <el-form-item label="设备编号：" prop="code">
                <span>{{model.code}}</span>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <span>{{model.alias}}</span>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <span>{{model.model}}</span>
            </el-form-item>
            <el-form-item label="生产厂家：" prop="company_produce">
                <span>{{model.company_produce}}</span>
            </el-form-item>
            <el-form-item label="使用单位：" prop="company_use">
                <span>{{model.company_use}}</span>
            </el-form-item>
            <el-form-item label="所在位置：" prop="location">
                <span>{{model.location}}</span>
            </el-form-item>
            <el-form-item label="关联数据采集器：" prop="check_code">
                <span>{{model.check_code}}</span>
            </el-form-item>
            <el-form-item label="数据采集器名称：" prop="check_name">
                <span>{{model.check_name}}</span>
            </el-form-item>
            <el-form-item label="通道号：" prop="channel_no">
                <span>{{model.channel_no}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <span>{{model.order_index}}</span>
            </el-form-item>
            <el-form-item label="流量预警阈值：" prop="flow_threshold">
                <span>{{model.flow_threshold}}</span>
            </el-form-item>
            <el-form-item label="压力预警阈值：" prop="pressure_threshold">
                <span>{{model.pressure_threshold}}</span>
            </el-form-item>
            <el-form-item label="抬动预警阈值：" prop="lift_threshold">
                <span>{{model.lift_threshold}}</span>
            </el-form-item>
            <el-form-item label="工作时间类型：" prop="work_time_type">
                <span>{{ transEnu(model.work_time_type, "work_time_type") }}</span>
            </el-form-item>
            <el-form-item label="工作开始时间：" prop="work_time_start" v-if="model.work_time_type==2">
                <span>{{model.work_time_start}}</span>
            </el-form-item>
            <el-form-item label="工作结束时间：" prop="work_time_end" v-if="model.work_time_type==2">
                <span>{{model.work_time_end}}</span>
            </el-form-item>
            <el-form-item label="添加人名称：" prop="creator_name">
                <span>{{model.creator_name}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="create_time">
                <span>{{model.create_time}}</span>
            </el-form-item>
            <el-form-item label="更新人名称：" prop="update_name">
                <span>{{model.update_name}}</span>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <span>{{model.update_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deviceExtractInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                check_id: '',
                check_code: '',
                check_name: '',
                channel_no: '',
                code: '',
                name: '',
                alias: '',
                model: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                flow_threshold: '',
                pressure_threshold: '',
                lift_threshold: ''
            },
            getObj:{
                url:'/api/admin/deviceextract/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['work_time_type'],
        };
    },
    methods: {}
};
</script>